import {Edge, Node} from 'reactflow';
import {IAppliedRule, IPredicate, RuleOperator} from '../../../../incase-domain/appliedRules';
import {ISlide} from '../../../../incase-domain/slide';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import {ActionNodeData} from '../RulesFlowEditor/nodes.types';

export function flowToRules(nodes: Node[], edges: Edge[], slides: ISlide[], labelFn: (index: number) => string): IAppliedRule[] {
    const rules: IAppliedRule[] = [];
    const predicateEdges = edges.filter((e) => e.id.startsWith('pred-'));
    const actionNodeMap = new Map(nodes.filter((n) => n.id.startsWith('action-')).map((n) => [n.id, n]));

    predicateEdges.forEach((edge, index) => {
        const elementId = edge.source.replace('question-', '');
        const answerIndex = Number(edge.sourceHandle?.replace('answer-', ''));
        const actionNode = actionNodeMap.get(edge.target);
        if (!actionNode) return;

        const {ruleType, slideIds, operator} = actionNode.data as ActionNodeData;
        if (!slideIds?.length) return;

        const parentSlide = slides.find((s) => s.elements?.some((el) => el.id === elementId));
        if (parentSlide?.hidden) return;

        const visibleSlideIds = slideIds.filter((id) => {
            const target = slides.find((s) => s._id === id);
            return target && !target.hidden;
        });
        if (!visibleSlideIds.length) return;

        const element = parentSlide?.elements?.find((el) => el.id === elementId);

        rules.push({
            name: labelFn(index),
            predicates: [
                {
                    elementType: element?.type ?? ELEMENT.QUESTION,
                    elementId,
                    answers: [answerIndex],
                    operator: operator ?? RuleOperator.IF,
                } as IPredicate,
            ],
            results: [{resultType: ruleType, slideIds: visibleSlideIds}],
        });
    });

    return rules;
}
